<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <PageTitle title="Business" :rows="rows" />
        <CCardBody>
          <SubNav :csv_export="csv_export" />
          <div class="overflow-auto">
            <b-table
              id="my-table"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              small
            >
              <!-- A custom formatted column -->
              <template #cell(uname)="data">
                <td>
                  <CIcon
                    :name="'cif-' + data.item.countryNameCode.toLowerCase()"
                    width="40"
                  />
                  {{ data.item.uname }}
                </td>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              style="float: right"
            ></b-pagination>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import firebase from "firebase";
import {
  timeConverter,
  to_24,
  from_0,
  getDateLabel,
} from "../../common-functions.js";
import * as Const from "../../const.js";
import PageTitle from "../component/PageTitle.vue";
import SubNav from "../component/SubNav.vue";

export default {
  name: "Business",
  components: { PageTitle, SubNav },
  data() {
    return {
      currentPage: 1,
      perPage: Const.perPage,
      items: [],

      fields: [
        {
          key: "name",
          label: "Name",
          _classes: "font-weight-bold",
          sortable: true,
        },
        { key: "uname", label: "User", sortable: true },
        { key: "amountSumGave", label: "Sum of Gave", sortable: true },
        { key: "amountSumGot", label: "Sum of Got", sortable: true },
        { key: "customerCount", label: "Count of Customer", sortable: true },
        { key: "createdAt", label: "Created At", sortable: true },
        { key: "updatedAt", label: "updated At", sortable: true },
      ],
      activePage: 1,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    need_refresh() {
      return (
        this.$store.state.selcountryCode +
        (this.$store.state.showSubNav.user
          ? "-" + this.$store.state.seluid
          : "") +
        (this.$store.state.showSubNav.business
          ? "-" + this.$store.state.selbid
          : "") +
        (this.$store.state.showSubNav.customer
          ? "-" + this.$store.state.selcid
          : "") +
        (this.$store.state.showSubNav.date
          ? "-" + getDateLabel(this.$store.state.from, this.$store.state.to)
          : "")
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  watch: {
    need_refresh: {
      immediate: true,
      handler(value) {
        this.load("data");
      },
    },
  },
  created() {
    this.$store.commit("set", [
      "showSubNav",
      { user: true, business: false, customer: false, date: true },
    ]);
  },
  methods: {
    load(type) {
      const db = firebase.firestore();
      if (type == "data") {
        console.log("seluid", this.$store.state.seluid);

        //if (this.seluid == "") return;

        var ref = db.collection("business");
        if (this.$store.state.seluid != "")
          ref = ref.where("uid", "==", this.$store.state.seluid);

        ref = ref.where("isDeleted", "==", false);

        if (this.$store.state.from != "")
          ref = ref.where("createdAt", ">=", from_0(this.$store.state.from));
        if (this.$store.state.to != "")
          ref = ref.where("createdAt", "<=", to_24(this.$store.state.to));

        if (this.$store.state.selcountryCode != "") {
          ref = ref.where(
            "userCountryNameCode",
            "==",
            this.$store.state.selcountryCode
          );
        }
        ref = ref.orderBy("createdAt", "desc");
        this.$store.commit("set", ["loading_data", true]);
        try {
          ref
            .orderBy("name")
            .get()
            .then((querySnapshot) => {
              this.items = [];
              this.page = 0;
              querySnapshot.forEach((doc) => {
                var business = {
                  name: doc.data().name,
                  uid: doc.data().uid,
                  uname: doc.data().userPhoneNumber,
                  countryNameCode: doc.data().userCountryNameCode,
                  amountSumGave: doc.data().amountSumGave,
                  amountSumGot: doc.data().amountSumGot,
                  createdAt: timeConverter(doc.data().createdAt.seconds),
                  updatedAt: timeConverter(doc.data().updatedAt.seconds),
                  customerCount: doc.data().customerCount,
                };

                this.items.push(business);
              });

              this.$store.commit("set", ["loading_data", false]);
            });
        } catch (e) {
          this.$store.commit("set", ["loading_data", false]);
        } finally {
        }
      }
    },
    rowClicked(item, index) {
      //this.$router.push({ path: `businesses/${this.items[index].uid}` });
      //this.$router.push({ path: `customers/${this.items[index].uid}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },

    csv_export() {
      let csvContent = "";

      var universalBOM = "\uFEFF";

      this.fields.forEach(function (row) {
        csvContent += row.label + ",";
      });
      csvContent += "\r\n";
      this.items.forEach(function (row) {
        var row_str = "";
        row_str += '"' + row.name + '",';
        row_str += '"' + row.uname + ' ",';
        row_str += '"' + row.amountSumGave + '",';
        row_str += '"' + row.amountSumGot + '",';
        row_str += '"' + row.customerCount + '",';
        row_str += '"' + row.createdAt + '",';
        row_str += '"' + row.updatedAt + '",';

        csvContent += row_str + "\r\n";
      });
      var universalBOM = "\uFEFF";
      var a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "data:text/csv; charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      a.setAttribute("download", "businesses" + this.need_refresh + ".csv");
      window.document.body.appendChild(a);
      a.click();
    },
  },
};
</script>
